import { useStage } from './useStage'

export default () => useStage('webauthn-authentication')
